import React, { Component } from "react";
import Avatar from '../../../assets/images/avatar.png';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/organizers/';





export default class OrganizerListPage extends Component {
    // constructor(props) {
    //     super(props)
    // }

    render() {
        return (
            <div>
               {/* <div class="form-back-link" onClick={() => this.props.HandleRouting('home')}>
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    <a>Back</a>
        </div> */}
                <div class="all-organizers-list-main">
                    <div class="container-fluid">
                    <div className="row">
                    <div className="col-6 col-md-3 col-lg-3">
                        <h3>Organizers</h3>
                        </div>
                        <div className="col-6 col-md-3 col-lg-3">
                        <div className="organizer-list-add-btn">
                        <button type="button" className="btn" onClick={() => this.props.AddOrganizer()}>Add Organizer</button>
                        </div>
                        </div>
                        </div>

                        <div class="organizers-list-div">
                            <div class="row">
                                <div class="col-md-12 col-lg-12 organizers-head-list-desktop">
                                    <div class="row">
                                        <div class="col-md-1 col-lg-1">
                                            <div class="users-list-head">
                                                <h5>Sr.No.</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>FullName</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Mobile Number</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Email Address</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="users-list-head">
                                                <h5>Status</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Category</h5>
                                            </div>
                                        </div>



                                    </div>

                                </div>
                                <div class="col-md-12 col-lg-12 organizers-list-desktop">
                                { this.props.organizerlist.length>0?

                                    this.props.organizerlist.map((item,i)=>(

                                    <div class="users-list-details" onClick={() => this.props.GetOrganizerDetails(item._id)}>
                                        <div class="row">
                                            <div class="col-md-1 col-lg-1">
                                                <div class="users-list-content">
                                                    <p>{i+1}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                    <p>{item.organizer_name}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                    <p>{item.organizer_mobile}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                    <p>{item.organizer_email}</p>
                                                </div>
                                            </div>
                                            {item.organizer_status === '1' || item.organizer_status === 1?
                                            <div class="col-md-1 col-lg-1">
                                            <div class="users-list-content">
                                                <p>Active</p>
                                            </div>
                                        </div>
                                        : <div class="col-md-1 col-lg-1">
                                        <div class="users-list-content">
                                            <p>InActive</p>
                                        </div>
                                    </div>
                                }
                                           
                                            <div class="col-md-2 col-lg-2">
                                                <div class="users-list-content">
                                                    <p>{item.organizer_category}</p>
                                                </div>
                                            </div>

                                        </div>



                                    </div>
                                    ))
        :''}
                                    
                                </div>

                                <div class="col-md-12 col-lg-12 organizers-list-mobile">
                                { this.props.organizerlist.length>0?

                                    this.props.organizerlist.map((item,i)=>(

                                    <div class="users-list-details" onClick={() => this.props.GetOrganizerDetails(item._id)}>
                                        <div class="row">
                                        <div class="col-4 col-md-1 col-lg-1">
                                        <div class="users-list-content-img">
                                               { item.organizer_image === '' || item.organizer_image === undefined  ?
                                               <img src={Avatar} alt="loading..."/>
                                               :
                                            <img src={img_path+ item.organizer_image.replace(',','')} alt="loading..." />
                                               }
                                        </div>
                                    </div>
                                           {/* <div class="col-md-1 col-lg-1">
                                                <div class="users-list-content">
                                                    <p>{i+1}</p>
                                                </div>
                                    </div> */}
                                            <div class="col-8 col-md-2 col-lg-2">
                                           
                                            
                                            <div class="users-list-content">
                                                    <p>{item.organizer_name}</p>
                                                </div>
                                            
                                                <div class="users-list-content">
                                                <p>{item.organizer_email}</p>
                                            </div>
                                               

                                            <div class="users-list-content">
                                            <p>{item.organizer_mobile}</p>
                                        </div>

                                        {item.organizer_status === '1' || item.organizer_status === 1?
                                       
                                        <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="defaultCheckedDisabled2" checked disabled/>
                                                        <label style={{color:'black'}} class="custom-control-label" for="defaultCheckedDisabled2">Active</label>
                                                      </div>
                                   
                                    :
                                    <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="defaultUncheckedDisabled2" disabled/>
                                    <label class="custom-control-label" for="defaultUncheckedDisabled2">Active</label>
                                  </div>
                               
                            }
                                                
                                            </div>
                                        </div>



                                    </div>
                                    ))
        :''}
                                    
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

            </div>
        )
    }
}

